import { SchedulePriceValidationType } from "@src/validation/SchedulePriceValidation";

export const schedulePriceFormat = (data: SchedulePriceValidationType, listingId: number) => {
	if (!data.startDate || !data.endDate) return;
	const startDateTime = adjustDate(data.startDate, data.startTimeHour, data.startTimeMinute, data.startTimeAbbreviation);
	const endDateTime = adjustDate(data.endDate, data.endTimeHour, data.endTimeMinute, data.endTimeAbbreviation);

	const finalData = {
		alterAmount: data.alterPriceBy,
		blackoutEnd: null,
		blackoutStart: null,
		endDateTime,
		endPrice: data.endPrice,
		listingIds: [listingId],
		priceCycleMinutes: +data.cycle,
		startDateTime,
		startPrice: data.startPrice,
	};

	return finalData;
};

function adjustDate(date: Date, hour: number, minute: number, abbreviation: string) {
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const day = String(date.getDate()).padStart(2, "0");
	const year = date.getFullYear();
	const newHour = hour < 10 ? `0${hour}` : hour;
	const newMinute = minute < 10 ? `0${minute}` : minute;

	return `${month}/${day}/${year} ${newHour}:${newMinute}:00 ${abbreviation}`;
}
